module.exports = __webpack_public_path__ + "img/image-thumb-13.9d02ebaa.webp";